import React from "react";
import T from "prop-types";
import classNames from "classnames";
import { calculateValue, conversionUnitAbbrev } from "LIB/formatters/weight";
import { Icon } from "MODULES/shared/components";
import Dimensions from "../Search/Dimensions";
import { KG_PER_LB, POUNDS, KILOS, WEIGHT_UNIT, WEIGHT } from "../../constants";
import { NetWeightAndDimsPopUp } from "./NetWeightAndDimsPopUp";

export default function WeightAndDims({ part: immutablePart }) {
  const part = immutablePart.toJS();

  const weightUnit = part[WEIGHT_UNIT];
  const weight = part[WEIGHT];
  const weightClass = classNames({
    "text-highlight": part.overweight
  });

  return (
    <table className="table table-condensed parts-details-table">
      <tbody>
        <tr>
          <th className="text-right">DM</th>
          <Dimensions part={part} showWarning={part.large_dimensions} />
          <NetWeightAndDimsPopUp part={part} />
        </tr>
        <tr>
          <th className="text-right">WT</th>
          <td>
            <span className={weightClass}>
              {part.overweight && (
                <span>
                  <Icon name="warning" />
                  &nbsp;&nbsp;
                </span>
              )}
              {weight} {weightUnit}
              <br />
              {calculateValue(weightUnit, weight)}{" "}
              {conversionUnitAbbrev(weightUnit)}
            </span>
          </td>
        </tr>
        {part.calculated_dim_weight && (
          <tr>
            <th className="text-right">DM WT</th>
            <td>
              {Math.ceil(part.calculated_dim_weight)} {POUNDS}
              <br />
              {Math.ceil(part.calculated_dim_weight * KG_PER_LB)} {KILOS}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

WeightAndDims.propTypes = {
  part: T.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/WeightAndDims.jsx